<template>
  <v-container fill-height class="mt-6 pt-6">
    <v-row justify="center" align="center">
      <v-col class="text-center">
        <v-row align="center" justify="center" class="mt-6 mb-6 pb-6">
          <v-btn
            color="primary"
            class="text-capitalize mx-2"
            x-large
            rounded
            outlined
            to="/massages"
          >
            {{ $t("explore") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize mx-2"
            x-large
            rounded
            outlined
            href="https://rafaellemassotherapie.youcanbook.me/"
            target="_blank"
          >
            {{ $t("booking") }}

            <v-icon right>mdi-open-in-new</v-icon>
          </v-btn>
        </v-row>
        <v-sheet class="rounded-xl">
          <Photo
            source="https://firebasestorage.googleapis.com/v0/b/sodaba.appspot.com/o/static%2FWebP%2FrafaelleESPACE_wp.webp?alt=media&token=7390922f-7c07-4fb1-933e-e4d09c98118a"
            edges="rounded-xl"
          />
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Photo from "../utils/Photos.vue";
export default {
  name: "LandingMain",
  components: {
    Photo,
  },

  data: () => ({}),
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>
<i18n>
{
  "en":{   
    "explore": "explore",
    "booking": "booking"
    },
    "fr":{    
    "explore":"explorer",
    "booking":"réservation"
    }
  }
</i18n>
